import { Button, Dialog, DialogContent, TextField } from "@mui/material";
import { useEffect, useMemo, useState } from "react";
import type { Group } from "../../lib/types";

export function availableFallbackGroups(groups: Group[], blockedGroupId: string) {
  return groups.filter((item) => item.id !== blockedGroupId && (!item.is_blocked || item.role === "owner"));
}

export function BlockedGroupModal({
  group,
  groups,
  onLeave,
  onSelectGroup,
  isLeaving,
}: {
  group: Group;
  groups: Group[];
  onLeave: () => void;
  onSelectGroup: (groupId: string) => void;
  isLeaving: boolean;
}) {
  const fallbackGroups = useMemo(() => availableFallbackGroups(groups, group.id), [groups, group.id]);
  const [targetGroupId, setTargetGroupId] = useState("");

  useEffect(() => {
    setTargetGroupId((current) => (current && fallbackGroups.some((item) => item.id === current) ? current : fallbackGroups[0]?.id || ""));
  }, [fallbackGroups]);

  return (
    <Dialog open aria-labelledby="blockedGroupTitle" slotProps={{ paper: { className: "modal records-modal blocked-group-modal" } }}>
      <DialogContent className="records-modal-content">
        <div className="records-modal-toolbar">
          <div>
            <h2 id="blockedGroupTitle">You are blocked in this group</h2>
            <p className="users-group-modal-subtitle">
              {group.name} is still listed in your groups, but shared finance data and settings are unavailable while access is blocked.
            </p>
          </div>
        </div>
        <div className="blocked-group-actions">
          <Button variant="outlined" color="error" type="button" disabled={isLeaving} onClick={onLeave}>
            Leave this group
          </Button>
          <div className="blocked-group-switcher">
            <TextField
              select
              label="Open another group"
              value={targetGroupId}
              disabled={!fallbackGroups.length}
              slotProps={{ select: { native: true } }}
              onChange={(event) => setTargetGroupId(event.target.value)}
            >
              {fallbackGroups.map((item) => (
                <option key={item.id} value={item.id}>{item.name}</option>
              ))}
            </TextField>
            <Button variant="contained" type="button" disabled={!targetGroupId} onClick={() => onSelectGroup(targetGroupId)}>
              Open group
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
